/**
 * 协同指挥路由
 * 2017-11-10
 * Bai.Zhiming
 */
"use strict";
angular.module("commandRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("front.plan.command.managegroups", { //分组管理
        url: '/managegroups',
        views: {
            "main@front.plan.command": {
                templateUrl: "./planningCenter/command/manageGroups/main_tpl.html",
                controller: "manageGroupsCtrl"
            }
        }
    }).
    state("front.plan.command.reportsummary", { //报题汇总
        url: "/reportsummary?groupid&groupname&starttime&endtime",
        views: {
            "main@front.plan.command": {
                templateUrl: "./planningCenter/command/reportSummary/main_tpl.html",
                controller: "reportSummaryCtrl"
            }
        }
    }).
    state("front.plan.command.topicssummary", { //选题汇总
        url: "/topicssummary?groupid&groupname&starttime&endtime",
        views: {
            "main@front.plan.command": {
                templateUrl: "./planningCenter/command/topicsSummary/main_tpl.html",
                controller: "topicsSummaryCtrl"
            }
        }
    }).state("front.plan.command.groupassignment",{
        url:"/groupassignment?groupid&reportid&taskid",
        views:{
            'main@front.plan.command':{
                templateUrl:"./planningCenter/command/groupAssignment/main_tpl.html",
                controller:"groupAssignmentCtrl",
            }
        },
    }).state('reportsummarynews', {
        url: "/reportsummarynews?reportId&iwoplatform&iwometadataid&iwochnldocid",
        views: {
            '': {
                templateUrl: './editingCenter/iWo/myManuscript/personalManuscript/news/news_tpl.html',
                controller: 'reportSummaryNewsCtrl',
            }
        }
    });
}]);